<template lang="pug">
  nav.pagination-container(v-if="last_page > 1")
    p(v-html="label")
    div.pagination
      .page-item(:class="{'disabled': disabled || current_page == 1}")
        a.page-link(@click.prevent="previousPage()")
          icon(icon="chevron-left")
          span.sr-only Previous
      select.page-item(v-model="selectedPage" @change="changePage(selectedPage)")
        option(
          v-for="page in pages"
          :key="page.number"
          :selected="page.number == current_page"
        ) {{ page.number }}
      .page-item(:class="{'disabled': disabled || current_page == last_page}")
        a.page-link(@click.prevent="nextPage()")
          span.sr-only Next
          icon(icon="chevron-right")
</template>

<script>
import {extend} from 'lodash-es'

export default {
  props: [
    'pagination',
    'disabled'
  ],
  data: () => ({
    paginated: false,
    current_page: 1,
    last_page: 1,
    per_page: 1,
    count: 1,
    total: 1,
    selectedPage: null,
  }),
  watch: {
    pagination(newValue) {
      extend(this, newValue)
      this.selectedPage = newValue.current_page || 1;
    }
  },
  computed: {
    pages() {
      for(var pages = [], page = 1; page <= this.last_page; page++)
      {
        pages.push({
          number: page,
          active: page == 1
        });
      }

      return pages;
    },
    label() {
      if ( this.count == 1 )
      {
        return;
      }

      if ( this.last_page == 1 )
      {
        return `Showing ${this.total} results.`
      }

      var from = (this.current_page - 1) * this.per_page + 1,
        to = Math.min(this.current_page * this.per_page, this.total);

      return `Showing ${from}&ndash;${to} of ${this.total} results.`
    }
  },
  methods: {
    changePage(page) {
      if (page != this.current_page) {
        this.current_page = Math.max(1, Math.min(page, this.last_page));
        this.$emit('page-changed', {page: this.current_page});
      }
    },
    previousPage() {
      this.changePage(this.current_page - 1)
    },
    nextPage() {
      this.changePage(this.current_page + 1)
    }
  }
}
</script>

<style lang="scss">
.pagination-container {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  p,
  ul {
    margin-bottom: 0;
  }

  select {
    appearance: none;
    width: auto;
    cursor: pointer;
    background-color: #ffffff;
    border: 2px solid #e8e8e8;
    border-left: 0;
    outline: none;
    padding: 0 35px 0 15px;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggc3Ryb2tlPSIjY2NjY2NjIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41IiBkPSJNNiA4bDQgNCA0LTQiLz48L3N2Zz4=");
    background-position: right 10px center;
    background-repeat: no-repeat;
    background-size: 1.5em 1.5em;
    print-color-adjust: exact;

    &:hover {
      background-color: #f0f0f0;
    }
  }
}
</style>
